const Language = Object.freeze({
    EN: "en",
    HU: "hu",
  });

const Sitemap = Object.freeze({
    HOME: "/",
    PRODUCTS: "/products",
  });
  
  
export { Language,Sitemap };